import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import Input from '@src/components/inputs/Input'
import { css } from '@emotion/react'

const TypeForm = () => {
	const { getFieldProps } = useMyProductFormContext()
	const { errorMsg } = getFieldProps('isOptionExist')

	return (
		<div>
			<div css={btnWrapperStyle}>
				<Input
					{...getFieldProps('isOptionExist')}
					type="checkbox"
					id="is_option_check"
					label="옵션 있음"
					errorMsg={undefined}
					labelStyle={css`
						margin-left: 0.5rem;
					`}
					wrapperStyle={css`
						flex-direction: row-reverse;
						align-items: center;
						justify-content: flex-end;
					`}
					css={css`
						border-radius: 8px;
						box-sizing: border-box;
						padding: 1.3rem 1.9rem;
						margin: 0px;
					`}
				/>
			</div>
			<div css={errStyle}>{errorMsg}</div>
		</div>
	)
}
const btnWrapperStyle = css`
	width: 20rem;
	display: flex;
	align-items: center;
	/* & > div {
		float: left;
	} */
	/* &:after {
		content: ' ';
		display: block;
		clear: both;
	} */
`
const errStyle = css`
	color: #de0000;
	font-size: 1.2rem;
	line-height: 2rem;
	font-weight: 600;
`
export default TypeForm
